import gql from 'graphql-tag';

export const GET_VOTER_COMMUNICATIONS = gql`
  query GetVoterCommConversations($where: ri_apps_prd_voter_comm_conversations_bool_exp) {
    rows: ri_apps_prd_voter_comm_conversations(where: $where, order_by: [{ created_at: desc }]) {
      conversation_id
      organization_id
      user_id
      created_at
      updated_at
      voter_comm_conversations_messages(order_by: [{ created_at: asc }]) {
        message_id
        content
        user_id
        created_at
      }
      voter_comm_conversations_conversation_metadata {
        voter_comm_conversation_metadata_metadata {
          id
          bill_number
          title
          state
          session
          namespace
          status
          last_action
          last_action_date
        }
      }
    }
  }
`;

export const GET_VOTER_COMMUNICATION_ONE = gql`
  query GetVoterCommConversationOne($conversation_id: Int!) {
    row: ri_apps_prd_voter_comm_conversations_by_pk(conversation_id: $conversation_id) {
      conversation_id
      organization_id
      user_id
      created_at
      updated_at
      voter_comm_conversations_messages(order_by: [{ created_at: asc }]) {
        message_id
        content
        user_id
        created_at
      }
      voter_comm_conversations_metadata {
        id
        bill_number
        title
        state
        session
        namespace
      }
      voter_comm_conversations_conversation_metadata {
        voter_comm_conversation_metadata_metadata {
          id
          bill_number
          title
          state
          session
          namespace
          pdf_url
          title
          status
          last_action
          last_action_date
          sponsors
        }
      }
    }
  }
`;

export const GET_VOTER_COMMUNICATIONS_METADATA = gql`
  query GetVoterCommMetadata($where: ri_apps_prd_voter_comm_metadata_bool_exp) {
    rows: ri_apps_prd_voter_comm_metadata(where: $where) {
      id
      session
      bill_number
      file_name
      namespace
      pdf_url
      state
      title
      status
      last_action
      last_action_date
      sponsors
      current_body
      created_at
      updated_at
      history
      progress
    }
  }
`;

export const CHECK_IF_VOTER_COMMUNICATIONS_METADATA_EXISTS = gql`
  query GetVoterCommMetadataCount($where: ri_apps_prd_voter_comm_metadata_bool_exp) {
    aggregate: ri_apps_prd_voter_comm_metadata_aggregate(where: $where) {
      aggregate {
        count
      }
    }
  }
`;

export const CREATE_VOTER_COMMUNICATION = gql`
  mutation CreateVoterCommConversation(
    $object: ri_apps_prd_voter_comm_conversations_insert_input!
  ) {
    row: insert_ri_apps_prd_voter_comm_conversations_one(object: $object) {
      conversation_id
    }
  }
`;

export const DELETE_VOTER_CONVERSATION = gql`
  mutation DeleteVoterConversation($conversation_id: Int!) {
    delete_ri_apps_prd_voter_comm_conversations_by_pk(conversation_id: $conversation_id) {
      conversation_id
    }
  }
`;

export const CREATE_VOTER_COMMUNICATION_MESSAGE = gql`
  mutation CreateVoterCommMessage($object: ri_apps_prd_voter_comm_messages_insert_input!) {
    row: insert_ri_apps_prd_voter_comm_messages_one(
      object: $object
      on_conflict: { constraint: voter_comm_messages_pkey, update_columns: [] }
    ) {
      message_id
    }
  }
`;

export const CREATE_VOTER_COMMUNICATION_CONVERSATION_METADATA = gql`
  mutation CreateVoterCommConversationMetadata(
    $objects: [ri_apps_prd_voter_comm_conversation_metadata_insert_input!]!
  ) {
    insert_ri_apps_prd_voter_comm_conversation_metadata(objects: $objects) {
      affected_rows
    }
  }
`;

export const GET_BILL_DETAILS = gql`
  query GetBillDetails($bill_number: String!, $state: String!) {
    rows: ri_apps_prd_voter_comm_metadata(
      where: { bill_number: { _eq: $bill_number }, state: { _eq: $state } }
    ) {
      id
      bill_number
      title
      state
      session
      pdf_url
      status
      last_action
      last_action_date
      current_body
      current_body
      history: voter_comm_metadata_bill_history {
        history
      }
      progress: voter_comm_metadata_bill_progress {
        progress
      }
      sponsors: voter_comm_metadata_bill_sponsors {
        sponsors
      }
      roll_call_votes: voter_comm_metadata_bill_roll_call_votes {
        roll_call_votes
      }
      similar_bills: voter_comm_metadata_similar_bills {
        sasts
      }
    }
  }
`;

export const GET_BILL_LOOKUP_DATA = gql`
  query GetBillLookupData($state: String!) {
    body: ri_apps_prd_voter_comm_metadata_body(where: { state: { _eq: $state } }) {
      body_id
      body_name
      body_abbr
      body_short
    }
    progress: ri_apps_prd_voter_comm_metadata_progress {
      progress_event_id
      event
    }
    sponsor_type: ri_apps_prd_voter_comm_metadata_sponsor_type {
      sponsor_type_id
      sponsor_type_desc
    }
    party: ri_apps_prd_voter_comm_metadata_parties {
      party_id
      abbreviation
      short_name
      name
    }
  }
`;

export const GET_ALL_BILL_SPONSORS = gql`
  query GetBillSponsors($states: [String!]!) {
    rows: ri_apps_prd_voter_comm_metadata_bill_sponsors(where: { state: { _in: $states } }) {
      id
      bill_number
      state
      sponsors
    }
  }
`;

export const GET_TRACKED_BILLS = gql`
  query GetTrackedBills($where: ri_apps_prd_voter_comm_bill_tracking_bool_exp) {
    rows: ri_apps_prd_voter_comm_bill_tracking(where: $where) {
      tracking_id
      bill_number
      notify
      created_at
      updated_at
      last_notified_on
      state
      voter_comm_bill_tracking_user {
        user_id
        email
      }
      voter_comm_bill_tracking_bill_object {
        bill_number
        title
      }
    }
  }
`;

export const TRACK_BILL = gql`
  mutation TrackBill($object: ri_apps_prd_voter_comm_bill_tracking_insert_input!) {
    row: insert_ri_apps_prd_voter_comm_bill_tracking_one(
      object: $object
      on_conflict: {
        constraint: voter_comm_bill_tracking_bill_number_user_id_organization_id_ke
        update_columns: [notify]
      }
    ) {
      tracking_id
    }
  }
`;

export const GET_BILL_CHAMBERS = gql`
  query GetBillChambers($states: [String!]!) {
    rows: ri_apps_prd_voter_comm_metadata_body(where: { state: { _in: $states } }) {
      body_id
      state
      role_id
      body_name
      body_abbr
      body_short
      body_role_abbr
      body_role_name
    }
  }
`;

export const GET_ORGANIZATIONS_WITH_CONVERSATION_COUNTS = gql`
  query GetOrganizationsWithConversationCounts(
    $limit: Int
    $offset: Int
    $order_by: [ri_apps_prd_organizations_order_by!]
  ) {
    rows: ri_apps_prd_organizations(
      where: { organizations_voter_comm_conversations: { organization_id: { _is_null: false } } }
      order_by: $order_by
      limit: $limit
      offset: $offset
    ) {
      organization_id
      name
      email
      start_date
      end_date
      organizations_status {
        name
        code
      }
      conversation_count: organizations_voter_comm_conversations_aggregate {
        aggregate {
          count
        }
      }
      last_conversation: organizations_voter_comm_conversations(
        order_by: [{ created_at: desc }]
        limit: 1
      ) {
        created_at
        updated_at
      }
    }
    total_organizations: ri_apps_prd_organizations_aggregate(
      where: { organizations_voter_comm_conversations: { organization_id: { _is_null: false } } }
    ) {
      aggregate {
        count
      }
    }
    total_conversations: ri_apps_prd_voter_comm_conversations_aggregate {
      aggregate {
        count
      }
    }
  }
`;
